/**
 * URL 参数覆盖（演示 / 自动化验收用）
 * ------------------------------------------------------------
 * 支持两种写法，均可直接分享给他人打开：
 *   · 查询串：  /?theme=dark&lang=en-US#/chat
 *   · 哈希串：  /#/chat?theme=dark&lang=en-US
 * 仅作为「初始值覆盖」，不写入 localStorage —— 避免别人打开演示链接后
 * 永久改掉你自己的偏好；用户一旦在界面里切换，仍按正常逻辑持久化。
 *
 * 用途：亮/暗 × 中/英 四态一键演示，以及无头浏览器截图验收。
 */

/** 读单个参数；查询串优先，其次哈希内的查询串 */
export function readParam(key: string): string | null {
  if (typeof location === 'undefined') return null
  const fromSearch = new URLSearchParams(location.search).get(key)
  if (fromSearch) return fromSearch
  const h = location.hash
  const qi = h.indexOf('?')
  if (qi > -1) {
    const v = new URLSearchParams(h.slice(qi + 1)).get(key)
    if (v) return v
  }
  return null
}
